import { faCamera, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress, Typography } from '@mui/material';
import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import DefaultHeading from '../../components/heading/DefaultHeading';
import { fetchConfig, updateClientConfig } from '../../services/managePoliciesService';
import { openPopup } from '../../stateManagement/actions/popupActions';
import './ManagePolicies.css';
import { policyFileObj, UploadFileButtonType } from './managePoliciesTypes';
import pdfIcon from "../../images/PDF.png";
import { IndentWrapper } from '../orderConfiguration/OrderConfiguration';
import QuestionHeading from '../../components/heading/QuestionHeading';
import { uploadImages } from '../../services/bannerServices';
import { useNavigate } from 'react-router-dom';
import { ConfirmationPopUp } from '../../components/popup/confirmationPopUp';
import { manageUpdateAccessObj } from '../manageUpdateAccess/manageUpdateAccessTypes';
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';
import { getLob } from '../../services/authenticationService';

const defaultPolicyFilesConfig: policyFileObj[] = [
    {
        "name": "tncLink",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "tncLink",
        "defaultValue": "",
        "possibleVals": [
            "string"
        ]
    }, {
        "name": "privacyLink",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "privacylink",
        "defaultValue": "",
        "possibleVals": [
            "string"
        ]
    }, {
        "name": "policyUpdateTime",
        "type": "number",
        "value": "",
        "docUrl": "",
        "description": "policyUpdateTime",
        "defaultValue": "",
        "possibleVals": []
    },
    {
        "name": "newPoliciesLink",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "newPoliciesLink",
        "defaultValue": "",
        "possibleVals": [
            "string"
        ]
    },
    {
        "name": "newTncLink",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "newTncLink",
        "defaultValue": "",
        "possibleVals": [
            "string"
        ]
    },
]

function FileLinkPreview(props: { fileLink: string, linkName: string }) {
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT = "Manage Policies"
    return <div className="manage-policy-file-link-preview"><a href={props.fileLink} target="_blank" >{translate(TranslationEnum.manage_policies, `Click here to view current {linkName}`, { "linkName": props.linkName })}</a></div>
}
export const UploadFileField = (props: UploadFileButtonType) => {
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const validateImageAndUpload = (file: File | undefined) => {
        if (file) {
            if (file.type === "application/pdf") {
                props.setFile(file);
            } else {
                openPopup("Alert", "Please choose a pdf");
            }
        }
    }
    const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target?.files) {
            validateImageAndUpload(event.target.files?.[0]);
        }
    }
    const handleClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
            fileInputRef.current.click();
            props.setFile(null);
        }
    }
    const handleCrossButton = () => {
        if (props.file) {
            props.setFile(null);
        }
    }
    return (<div className={"genericImageUploadContainer" + (props.className ? ` ${props.className}` : "")}>
        <div className="genericImageUpload"
            onClick={handleClick}
        >
            {props.file ? (
                <>
                    <img
                        src={pdfIcon}
                        height="60"
                        width="auto"
                        alt="banner preview"
                    />
                    <Typography variant="subtitle1">
                        {props.fileName}
                    </Typography>
                </>
            ) : (
                <>
                    <FontAwesomeIcon fontSize="45px" icon={faCamera} />
                    <Typography variant="subtitle1">
                        {props.label}
                    </Typography>
                </>
            )}
            <input
                type="file"
                onChange={handleImageUpload}
                hidden
                ref={fileInputRef}
                accept="application/pdf"
            />
        </div>
        {props.file ? <div className="genericImageUploadCrossContainer">
            <FontAwesomeIcon
                className="genericImageUploadCross"
                icon={faXmark}
                onClick={handleCrossButton}
            />
        </div> : <></>}
    </div>)
}
function ManagePolicies() {
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT = "Manage Policies"
    const CUR_COMPONENT_COMMON = "commonPortal";
    const [policyFilesArray, setPolicyFilesArray] = useState<policyFileObj[]>([]);
    const [termsAndCondFile, setTermsAndCondFile] = useState<File | null>(null);
    const [privacyPolicyFile, setPrivacyPolicyFile] = useState<File | null>(null);
    const [newPoliciesFile, setNewPoliciesFile] = useState<File | null>(null);
    const [newTermsAndConditionsFile, setNewTermsAndConditionsFile] = useState<File | null>(null);
    const [showSubmitLoader, setShowSubmitLoader] = useState<boolean>(false);
    const configRef = useRef<any[]>([]);
    const navigate = useNavigate();

    const [openConfirmPopup, setOpenConfirmPopup] = useState<boolean>(false);
    useEffect(() => {
        async function getAndSetPolicyFiles() {
            try {
                const configResponse = await fetchConfig();
                configRef.current = configResponse;
                const fileArray = [];
                const termsCondObj = configResponse.find((object: policyFileObj) => {
                    return object.name === "tncLink";
                })
                termsCondObj ? fileArray.push(termsCondObj) : fileArray.push(defaultPolicyFilesConfig[0]);

                const privacyPolicyObj = configResponse.find((object: policyFileObj) => {
                    return object.name === "privacyLink";
                })

                privacyPolicyObj ? fileArray.push(privacyPolicyObj) : fileArray.push(defaultPolicyFilesConfig[1]);

                const updatedTimeObj = configResponse.find((object: policyFileObj) => {
                    return object.name === "policyUpdateTime";
                })

                updatedTimeObj ? fileArray.push(updatedTimeObj) : fileArray.push(defaultPolicyFilesConfig[2]);

                const newPoliciesObj = configResponse.find((object: policyFileObj) => {
                    return object.name === "newPoliciesLink";
                })

                newPoliciesObj ? fileArray.push(newPoliciesObj) : fileArray.push(defaultPolicyFilesConfig[3]);

                const newTermsAndConditionsObj = configResponse.find((object: policyFileObj) => {
                    return object.name === "newTncLink";
                })

                newTermsAndConditionsObj ? fileArray.push(newTermsAndConditionsObj) : fileArray.push(defaultPolicyFilesConfig[4]);
                setPolicyFilesArray(fileArray);
            } catch (err) {
                openPopup("Error", "Something went wrong");
            }
        }
        getAndSetPolicyFiles();
    }, [])
    async function handlePolicySubmit() {
        try {
            setShowSubmitLoader(true);
            if (!termsAndCondFile && !privacyPolicyFile && !newPoliciesFile && !newTermsAndConditionsFile) {
                openPopup("Alert", "Please select a file to proceed");
                return;
            }
            const fileFormData = new FormData();

            if (termsAndCondFile) fileFormData.append("files", termsAndCondFile);
            if (privacyPolicyFile) fileFormData.append("files", privacyPolicyFile);
            if (newPoliciesFile) fileFormData.append("files", newPoliciesFile);
            if (newTermsAndConditionsFile) fileFormData.append("files", newTermsAndConditionsFile);

            const blobUrls = fileFormData.has("files")
                ? await uploadImages(fileFormData)
                : [];
            if (!Array.isArray(blobUrls)) {
                openPopup("Error", blobUrls.message)
                setShowSubmitLoader(false);
                return;
            }
            let blobIdx = 0;
            const newConfig = [...configRef.current];
            if (termsAndCondFile) {
                const termsAndCondIndex = configRef.current.findIndex((configObj: policyFileObj) => {
                    return configObj.name === "tncLink"
                })
                if (termsAndCondIndex !== -1) {
                    newConfig[termsAndCondIndex] = {
                        ...policyFilesArray[0],
                        value: blobUrls[blobIdx]
                    }
                } else {
                    newConfig.push({
                        ...policyFilesArray[0],
                        value: blobUrls[blobIdx]
                    })
                }
                blobIdx++;
            }
            if (privacyPolicyFile) {
                const privacyPolicyIndex = configRef.current.findIndex((configObj: policyFileObj) => {
                    return configObj.name === "privacyLink"
                })
                if (privacyPolicyIndex !== -1) {
                    newConfig[privacyPolicyIndex] = {
                        ...policyFilesArray[1],
                        value: blobUrls[blobIdx]
                    }
                } else {
                    newConfig.push({
                        ...policyFilesArray[1],
                        value: blobUrls[blobIdx]
                    })
                }
            }

            if (newPoliciesFile) {
                const newPoliciesIndex = configRef.current.findIndex((configObj: policyFileObj) => {
                    return configObj.name === "newPoliciesLink"
                })
                if (newPoliciesIndex !== -1) {
                    newConfig[newPoliciesIndex] = {
                        ...policyFilesArray[3],
                        value: blobUrls[blobIdx]
                    }
                } else {
                    newConfig.push({
                        ...policyFilesArray[3],
                        value: blobUrls[blobIdx]
                    })
                }
                blobIdx++;
            }
            if (newTermsAndConditionsFile) {
                const newTermsAndConditionsIndex = configRef.current.findIndex((configObj: policyFileObj) => {
                    return configObj.name === "newTncLink"
                })
                if (newTermsAndConditionsIndex !== -1) {
                    newConfig[newTermsAndConditionsIndex] = {
                        ...policyFilesArray[4],
                        value: blobUrls[blobIdx]
                    }
                } else {
                    newConfig.push({
                        ...policyFilesArray[4],
                        value: blobUrls[blobIdx]
                    })
                }
                blobIdx++;
            }
            const policyUpdatedTimeIndex = configRef.current.findIndex((configObj: policyFileObj) => {
                return configObj.name === "policyUpdateTime"
            })
            if (policyUpdatedTimeIndex !== -1) {
                newConfig[policyUpdatedTimeIndex] = {
                    ...policyFilesArray[2],
                    value: Date.now()
                }
            } else {
                newConfig.push({
                    ...policyFilesArray[2],
                    value: Date.now()
                })
            }
            const configName = "customer_configuration";
            let finalRequestBody = {
                domainName: "clientconfig",
                domainType: configName,
                domainValues: newConfig,
                lob: getLob(),
            };
            validateWithOtp((veriedUser?: manageUpdateAccessObj, verifyResponse?: any) => {
                doFinalSubmit(veriedUser, verifyResponse);
            }, undefined, "all", `/metadata/clientconfig?name=${configName}`, finalRequestBody, "PUT");
        } catch (err: any) {
            console.log(err);
            openPopup("Error", err.message)
        } finally {
            setShowSubmitLoader(false);
        }
    }
    async function doFinalSubmit(verifiedUser?: manageUpdateAccessObj, verifyResponse?: any) {
        try {
            setShowSubmitLoader(true);
            if (verifyResponse.status === 200 || verifyResponse.status === 201) {
                openPopup("Success", "Policies updated successfully", () => {
                    navigate(0);
                });
            } else {
                throw new Error("Error occured while updating config");
            }
        } catch (err: any) {
            throw new Error(err.message);
        } finally {
            setShowSubmitLoader(false);
        }
    }
    return (
        <div className='manage-policies-container'>
            <DefaultHeading heading={translate(TranslationEnum.manage_policies, "Manage Policies")} showDefaultBackButton={true}></DefaultHeading>

            <IndentWrapper indent={0}>
                <QuestionHeading>{translate(TranslationEnum.manage_policies, "Upload Terms And Conditions")}</QuestionHeading>
                <IndentWrapper indent={1}>
                    {policyFilesArray[0]?.value ? <FileLinkPreview fileLink={policyFilesArray[0].value || "#"} linkName={"T&C"} /> : <>{translate(TranslationEnum.common_portal, "There is no previous file for preview")}</>}
                    <UploadFileField className="manage-policies-file-upload" file={termsAndCondFile} setFile={setTermsAndCondFile} fileName={termsAndCondFile?.name} label={translate(TranslationEnum.manage_policies, "Upload Terms & Conditions PDF Document")} />
                </IndentWrapper>

                <QuestionHeading>{translate(TranslationEnum.manage_policies, "Upload Privacy Policy")}</QuestionHeading>
                <IndentWrapper indent={1}>
                    {policyFilesArray[1]?.value ? <FileLinkPreview fileLink={policyFilesArray[1].value} linkName={"Privacy and Document"} /> : <>{translate(TranslationEnum.common_portal, "There is no previous file for preview")}</>}
                    <UploadFileField className="manage-policies-file-upload" file={privacyPolicyFile} setFile={setPrivacyPolicyFile} fileName={privacyPolicyFile?.name} label={translate(TranslationEnum.manage_policies, "Upload Privacy Policy PDF Document")} />
                </IndentWrapper>

                <QuestionHeading>{translate(TranslationEnum.manage_policies, "Upload Terms and Conditions 2")}</QuestionHeading>
                <IndentWrapper indent={1}>
                    {policyFilesArray[4]?.value ? <FileLinkPreview fileLink={policyFilesArray[4].value} linkName={"T&C 2"} /> : <>{translate(TranslationEnum.common_portal, "There is no previous file for preview")}</>}
                    <UploadFileField className="manage-policies-file-upload" file={newTermsAndConditionsFile} setFile={setNewTermsAndConditionsFile} fileName={newTermsAndConditionsFile?.name} label={translate(TranslationEnum.manage_policies, "Upload New Terms and Conditions PDF Document")} />
                </IndentWrapper>
                
                <QuestionHeading>{translate(TranslationEnum.manage_policies, "Upload Privacy Policy 2")}</QuestionHeading>
                <IndentWrapper indent={1}>
                    {policyFilesArray[3]?.value ? <FileLinkPreview fileLink={policyFilesArray[3].value} linkName={"Privacy and Document 2"} /> : <>{translate(TranslationEnum.common_portal, "There is no previous file for preview")}</>}
                    <UploadFileField className="manage-policies-file-upload" file={newPoliciesFile} setFile={setNewPoliciesFile} fileName={newPoliciesFile?.name} label={translate(TranslationEnum.manage_policies, "Upload New Privacy Policy PDF Document")} />
                </IndentWrapper>

            </IndentWrapper>

            <div className="create-bucket-submit-button-container">
                <button
                    onClick={() => setOpenConfirmPopup(true)}
                    className="create-bucket-submit-button"
                    disabled={showSubmitLoader}
                >
                    {showSubmitLoader ? (
                        <div>
                            <CircularProgress size={15} color="inherit" />
                            <span className="circular-progress-container">{translate(TranslationEnum.common_portal, "SUBMIT")}</span>
                        </div>
                    ) : (
                        <> {translate(TranslationEnum.common_portal, "SUBMIT")}</>
                    )}
                </button>
            </div>
            <ConfirmationPopUp
                openConfirmModal={openConfirmPopup}
                message={"Are you sure want to upload the following documents ?"}
                setOpenConfirmModal={() => {
                    setOpenConfirmPopup(false);
                }}
                successMethod={() => {
                    handlePolicySubmit();
                }}
            />
        </div>
    )
}

export default ManagePolicies;

